module.exports = __webpack_public_path__ + "img/subscription-discount-10nis.5d5ec6fa.png";